export enum ChannelPaymentType {
  FREE = 'free',
  RECURRING = 'recurring',
  ONE_TIME = 'oneTime',
}

export enum ChannelBillingInterval {
  MONTHLY = 'monthly',
  ANNUALLY = 'annually',
}

export interface ChannelRecurringPrice {
  enabled: boolean
  amount: number
}

export interface ChannelPaymentSetupValue {
  paymentType: ChannelPaymentType
  currency: string
  recurring: Record<ChannelBillingInterval, ChannelRecurringPrice>
  oneTimeAmount: number
  isLivePayment: boolean
}

export enum ChannelMembershipType {
  FREE = 'FREE',
  PAID = 'PAID',
}

export enum ChannelMembershipPriceType {
  ONE_TIME = 'ONE_TIME',
  RECURRING = 'RECURRING',
}

export enum ChannelMembershipFrequency {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export interface ChannelMembershipPrice {
  type: ChannelMembershipPriceType
  price: number
  currency: string
  frequency?: ChannelMembershipFrequency
  paymentPriceId?: string
}

export interface ChannelMembershipMeta {
  type: ChannelMembershipType
  paymentProductId?: string
  offers?: ChannelMembershipPrice[]
  isLivePayment?: boolean
}

export type ChannelMembershipSettingsPayload =
  | { membershipType: ChannelMembershipType.FREE }
  | { membershipType: ChannelMembershipType.PAID; prices: ChannelMembershipPrice[]; isLivePayment: boolean }

export interface UpdateChannelMembershipSettingsInput {
  channelId: string
  membershipType: ChannelMembershipType
  prices?: ChannelMembershipPrice[]
  isLivePayment?: boolean
}
